import { FileBarChartIcon } from "lucide-react";
import { PortalShell } from "../components/portal-shell.js";

export function ReportsPage() {
	return (
		<PortalShell activeId="reports" pageTitle="Reports">
			<div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
				<div className="mb-8 border-b border-border pb-6">
					<h1 className="text-[28px] font-semibold leading-tight tracking-[-0.025em] text-foreground">
						Reports
					</h1>
					<p className="mt-1 text-[13.5px] text-muted-foreground">
						Generate and download compliance and audit reports.
					</p>
				</div>
				<EmptyState
					icon={FileBarChartIcon}
					title="Reports coming soon"
					description="Exportable compliance reports, audit logs, and scheduled report delivery will appear here."
				/>
			</div>
		</PortalShell>
	);
}

function EmptyState({
	icon: Icon,
	title,
	description,
}: {
	icon: React.ComponentType<{ className?: string; strokeWidth?: number }>;
	title: string;
	description: string;
}) {
	return (
		<div className="flex min-h-[360px] flex-col items-center justify-center rounded-[14px] border border-dashed border-border bg-card px-8 py-16 text-center">
			<div className="mb-4 flex h-14 w-14 items-center justify-center rounded-[14px] border border-border bg-muted/50">
				<Icon className="h-6 w-6 text-muted-foreground" strokeWidth={1.5} />
			</div>
			<p className="text-[15px] font-semibold text-foreground">{title}</p>
			<p className="mt-1.5 max-w-[340px] text-[13px] text-muted-foreground">{description}</p>
		</div>
	);
}
